window.addEventListener('load', () => {
  if (document.getElementById('agence__video')) {
    const videoAgence = new Plyr('#agence__video', {
      controls: ['play-large', 'play', 'progress', 'volume', 'fullscreen'],
    });
  }
});
